"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleError = void 0;
const common_1 = require("@finley-technologies/common");
const handleError = ({ err, prefix, }) => {
    if (common_1.typeguards.isFinleyErrorType(err)) {
        return [`${prefix} Err: ${err.externalMessage || err.message}`];
    }
    if (common_1.typeguards.isErrorType(err)) {
        return [`${prefix} Err: ${err.message}`];
    }
    return [`${prefix} Err: Unknown error, please seek technical assistance.`];
};
exports.handleError = handleError;
//# sourceMappingURL=utils.js.map